import {
  createThis2j2avj17cvnv2 as createThis,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace,
  VOID7hggqo3abtya as VOID,
  indexOfwa4w6635jewi as indexOf,
  ArrayList3it5z8td81qkl as ArrayList,
  split2bvyvnrlcifjv as split,
  Unit_instanceat14thlj150z as Unit_instance,
  joinToString1cxrrlmo0chqs as joinToString,
  startsWith26w8qjqapeeq6 as startsWith,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
  trim6jpmwojjgb3l as trim,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
  lastIndexOfpmd3ei5son2n as lastIndexOf,
  substringBefore3n7kj60w69hju as substringBefore,
  contains2el4s70rdq4ld as contains,
  Enum3alwj03lh1n41 as Enum,
  Long2qws0ah9gnpki as Long,
  toString30pk9tzaqopn as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get6d5x931vk0s as get,
  protoOf180f3jzyo7rfj as protoOf,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  printStackTrace18lnx7a39cni as printStackTrace,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  copyToArray2j022khrow2yi as copyToArray,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  toLongw1zpgk99d84b as toLong,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  toString1pkumu07cwy4m as toString_0,
  boxApply1qmzdb3dh90hg as boxApply,
  arrayConcat3qsij7vh68m69 as arrayConcat,
  toList383f556t1dixk as toList,
  toString14fd7g605f91p as toString_1,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance,
  DateTime__toString_impl_cnueje2ackcuvowzg0n as DateTime__toString_impl_cnueje,
  DateTime2gld4ho36azq9 as DateTime,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  asyncz02dsa2nb2zt as async,
  CoroutineScopefcb5f5dwqcas as CoroutineScope_0,
} from './kotlinx-coroutines-core.mjs';
import {
  readBytesUpTo2jsx0o5buj2sw as readBytesUpTo,
  copyTo30i4m6zj8kjfa as copyTo,
  openAsync37anb1e84urmo as openAsync,
  openSync2m3qn99fqytu0 as openSync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName } from './korlibs-platform-root-korlibs-platform.mjs';
import {
  toString2x583ovdqfjci as toString_2,
  toByteArraybbc3ng3wgt1d as toByteArray,
  get_UTF82geyfhi1l22xl as get_UTF8,
} from './korlibs-string-root-korlibs-string.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import { Companion_getInstance1vfndg47rf0 as Companion_getInstance_0 } from './korlibs-io-fs-root-korlibs-io-fs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class FinalVfsFile {
  static u28(file) {
    var $this = createThis(this);
    $this.t28_1 = file;
    return $this;
  }
  static v28(vfs, path) {
    return this.u28(vfs.oi(path));
  }
  w28() {
    return this.t28_1.z28_1;
  }
  c29() {
    return this.t28_1.a29_1;
  }
  toString() {
    return 'FinalVfsFile(file=' + this.t28_1.toString() + ')';
  }
  hashCode() {
    return this.t28_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FinalVfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof FinalVfsFile ? other : THROW_CCE();
    if (!this.t28_1.equals(tmp0_other_with_cast.t28_1))
      return false;
    return true;
  }
}
class VfsNamed {
  constructor(pathInfo) {
    this.f29_1 = pathInfo;
  }
  e29() {
    return this.f29_1;
  }
}
class VfsOpenMode extends Enum {
  constructor(name, ordinal, cmode, write, createIfNotExists, truncate, read, append, createNew) {
    createIfNotExists = createIfNotExists === VOID ? false : createIfNotExists;
    truncate = truncate === VOID ? false : truncate;
    read = read === VOID ? true : read;
    append = append === VOID ? false : append;
    createNew = createNew === VOID ? false : createNew;
    super(name, ordinal);
    this.i29_1 = cmode;
    this.j29_1 = write;
    this.k29_1 = createIfNotExists;
    this.l29_1 = truncate;
    this.m29_1 = read;
    this.n29_1 = append;
    this.o29_1 = createNew;
  }
}
class VfsStat {
  constructor(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance().e1y_1 : createTime;
    modifiedTime = modifiedTime === VOID ? createTime : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    kind = kind === VOID ? null : kind;
    id = id === VOID ? null : id;
    exception = exception === VOID ? null : exception;
    this.p29_1 = file;
    this.q29_1 = exists;
    this.r29_1 = isDirectory;
    this.s29_1 = size;
    this.t29_1 = device;
    this.u29_1 = inode;
    this.v29_1 = mode;
    this.w29_1 = owner;
    this.x29_1 = group;
    this.y29_1 = createTime;
    this.z29_1 = modifiedTime;
    this.a2a_1 = lastAccessTime;
    this.b2a_1 = extraInfo;
    this.c2a_1 = kind;
    this.d2a_1 = id;
    this.e2a_1 = exception;
  }
  e29() {
    return this.p29_1.e29();
  }
  f2a(showFile) {
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList.w(16);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.VfsStat.toString.<anonymous>' call
    if (showFile)
      this_0.h('file=' + this.p29_1.toString());
    else
      this_0.h('file=' + this.p29_1.g2a());
    this_0.h('exists=' + this.q29_1);
    this_0.h('isDirectory=' + this.r29_1);
    this_0.h('size=' + this.s29_1.toString());
    this_0.h('device=' + this.t29_1.toString());
    this_0.h('inode=' + this.u29_1.toString());
    this_0.h('mode=' + this.v29_1);
    this_0.h('owner=' + this.w29_1);
    this_0.h('group=' + this.x29_1);
    this_0.h('createTime=' + DateTime__toString_impl_cnueje(this.y29_1));
    this_0.h('modifiedTime=' + DateTime__toString_impl_cnueje(this.z29_1));
    this_0.h('lastAccessTime=' + DateTime__toString_impl_cnueje(this.a2a_1));
    this_0.h('extraInfo=' + toString(this.b2a_1));
    if (!(this.c2a_1 == null)) {
      this_0.h('kind=' + toString(this.c2a_1));
    }
    this_0.h('id=' + this.d2a_1);
    return 'VfsStat(' + joinToString(this_0, ', ') + ')';
  }
  toString() {
    return this.f2a(true);
  }
  h2a(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    return new VfsStat(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception);
  }
  i2a(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception, $super) {
    file = file === VOID ? this.p29_1 : file;
    exists = exists === VOID ? this.q29_1 : exists;
    isDirectory = isDirectory === VOID ? this.r29_1 : isDirectory;
    size = size === VOID ? this.s29_1 : size;
    device = device === VOID ? this.t29_1 : device;
    inode = inode === VOID ? this.u29_1 : inode;
    mode = mode === VOID ? this.v29_1 : mode;
    owner = owner === VOID ? this.w29_1 : owner;
    group = group === VOID ? this.x29_1 : group;
    createTime = createTime === VOID ? this.y29_1 : createTime;
    modifiedTime = modifiedTime === VOID ? this.z29_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? this.a2a_1 : lastAccessTime;
    extraInfo = extraInfo === VOID ? this.b2a_1 : extraInfo;
    kind = kind === VOID ? this.c2a_1 : kind;
    id = id === VOID ? this.d2a_1 : id;
    exception = exception === VOID ? this.e2a_1 : exception;
    return $super === VOID ? this.h2a(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) : $super.h2a.call(this, file, exists, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, kind, id, exception);
  }
  hashCode() {
    var result = this.p29_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.q29_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r29_1) | 0;
    result = imul(result, 31) + this.s29_1.hashCode() | 0;
    result = imul(result, 31) + this.t29_1.hashCode() | 0;
    result = imul(result, 31) + this.u29_1.hashCode() | 0;
    result = imul(result, 31) + this.v29_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.w29_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x29_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.y29_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.z29_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.a2a_1) | 0;
    result = imul(result, 31) + (this.b2a_1 == null ? 0 : hashCode(this.b2a_1)) | 0;
    result = imul(result, 31) + (this.c2a_1 == null ? 0 : hashCode(this.c2a_1)) | 0;
    result = imul(result, 31) + (this.d2a_1 == null ? 0 : getStringHashCode(this.d2a_1)) | 0;
    result = imul(result, 31) + (this.e2a_1 == null ? 0 : hashCode(this.e2a_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsStat))
      return false;
    var tmp0_other_with_cast = other instanceof VfsStat ? other : THROW_CCE();
    if (!this.p29_1.equals(tmp0_other_with_cast.p29_1))
      return false;
    if (!(this.q29_1 === tmp0_other_with_cast.q29_1))
      return false;
    if (!(this.r29_1 === tmp0_other_with_cast.r29_1))
      return false;
    if (!this.s29_1.equals(tmp0_other_with_cast.s29_1))
      return false;
    if (!this.t29_1.equals(tmp0_other_with_cast.t29_1))
      return false;
    if (!this.u29_1.equals(tmp0_other_with_cast.u29_1))
      return false;
    if (!(this.v29_1 === tmp0_other_with_cast.v29_1))
      return false;
    if (!(this.w29_1 === tmp0_other_with_cast.w29_1))
      return false;
    if (!(this.x29_1 === tmp0_other_with_cast.x29_1))
      return false;
    if (!equals(this.y29_1, tmp0_other_with_cast.y29_1))
      return false;
    if (!equals(this.z29_1, tmp0_other_with_cast.z29_1))
      return false;
    if (!equals(this.a2a_1, tmp0_other_with_cast.a2a_1))
      return false;
    if (!equals(this.b2a_1, tmp0_other_with_cast.b2a_1))
      return false;
    if (!equals(this.c2a_1, tmp0_other_with_cast.c2a_1))
      return false;
    if (!(this.d2a_1 == tmp0_other_with_cast.d2a_1))
      return false;
    if (!equals(this.e2a_1, tmp0_other_with_cast.e2a_1))
      return false;
    return true;
  }
}
class Companion {}
class VfsCachedStatContext {
  constructor(stat) {
    this.j2a_1 = stat;
  }
  t1() {
    return Companion_instance;
  }
}
class Companion_0 {
  k2a() {
    return Standard_STRING_getInstance();
  }
}
class Standard extends Enum {}
class Vfs$Proxy$initOnce$slambda {
  constructor(this$0) {
    this.l2a_1 = this$0;
  }
  a1r($this$async, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$async), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Vfs {
  constructor($box) {
    boxApply(this, $box);
  }
  g2a() {
    return '';
  }
  c2b(path) {
    return _PathInfo___get_fullPath__impl__21fx6x(lightCombine(get_pathInfo(this.g2a()), get_pathInfo(path)));
  }
  d2b() {
    return new VfsFile(this, '');
  }
  oi(path) {
    return this.d2b().oi(path);
  }
  u2a(path) {
    return this.d2b().oi(path);
  }
  m1s($completion) {
    return Unit_instance;
  }
  e2b(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) {
    // Inline function 'kotlin.also' call
    var this_0 = new VfsStat(this.u2a(path), true, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, VOID, id);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.Vfs.createExistsStat.<anonymous>' call
    if (cache)
      this_0.p29_1.b29_1 = this_0;
    return this_0;
  }
  f2b(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache, $super) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance().e1y_1 : createTime;
    modifiedTime = modifiedTime === VOID ? Companion_getInstance().e1y_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    id = id === VOID ? null : id;
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.e2b(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) : $super.e2b.call(this, path, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, id, cache);
  }
  g2b(path, extraInfo, cache, exception) {
    return new VfsStat(this.u2a(path), false, false, new Long(0, 0), new Long(-1, -1), new Long(-1, -1), 511, 'nobody', 'nobody', Companion_getInstance().e1y_1, Companion_getInstance().e1y_1, Companion_getInstance().e1y_1, extraInfo, VOID, VOID, exception);
  }
  h2b(path, extraInfo, cache, exception, $super) {
    extraInfo = extraInfo === VOID ? null : extraInfo;
    cache = cache === VOID ? false : cache;
    exception = exception === VOID ? null : exception;
    return $super === VOID ? this.g2b(path, extraInfo, cache, exception) : $super.g2b.call(this, path, extraInfo, cache, exception);
  }
  w2a(path, mode, $completion) {
    unsupported(this);
  }
  a2b(path, range, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readRange__lxd64t_0.bind(VOID, this, path, range), $completion);
  }
  b2b(path, content, attributes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_put__cb93wb_0.bind(VOID, this, path, content, attributes), $completion);
  }
  i2b(path, content, attributes, $completion) {
    return this.b2b(path, openAsync(content), attributes, $completion);
  }
  x2a(path, $completion) {
    return this.h2b(path);
  }
  y2a(path, attributes, $completion) {
    unsupported(this);
  }
  z2a(path, attributes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_mkdirs__lgtbdw.bind(VOID, this, path, attributes), $completion);
  }
  d29(path, $completion) {
    return FinalVfsFile.v28(this, path);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
}
class Proxy extends Vfs {
  constructor() {
    super();
    this.m2a_1 = null;
  }
  d29(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getUnderlyingUnscapedFile__y1cdv2.bind(VOID, this, path), $completion);
  }
  n2a($completion) {
  }
  o2a($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_initOnce__uuyf07.bind(VOID, this), $completion);
  }
  w2a(path, mode, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea.bind(VOID, this, path, mode), $completion);
  }
  a2b(path, range, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readRange__lxd64t.bind(VOID, this, path, range), $completion);
  }
  b2b(path, content, attributes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_put__cb93wb.bind(VOID, this, path, content, attributes), $completion);
  }
  x2a(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc.bind(VOID, this, path), $completion);
  }
  y2a(path, attributes, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_mkdir__s6s291.bind(VOID, this, path, attributes), $completion);
  }
}
class VfsFile extends VfsNamed {
  constructor(vfs, path) {
    super(get_pathInfo(path));
    this.y28_1 = new Mixin();
    this.z28_1 = vfs;
    this.a29_1 = path;
    this.b29_1 = null;
  }
  r10(_set____db54di) {
    this.y28_1.r10(_set____db54di);
  }
  s10() {
    return this.y28_1.s10();
  }
  l2b() {
    return new VfsFile(this.z28_1, get_folder_0(this));
  }
  d2b() {
    return this.z28_1.d2b();
  }
  g2a() {
    return this.z28_1.c2b(this.a29_1);
  }
  oi(path) {
    return new VfsFile(this.z28_1, _PathInfo___get_fullPath__impl__21fx6x(combine(get_pathInfo(this.a29_1), get_pathInfo(path))));
  }
  s2a(content, attributes, $completion) {
    return this.z28_1.b2b(this.a29_1, content, toList(attributes), $completion);
  }
  k2b(data, attributes, $completion) {
    return this.z28_1.i2b(this.a29_1, data, toList(attributes), $completion);
  }
  q2a(mode, $completion) {
    return this.z28_1.w2a(this.a29_1, mode, $completion);
  }
  m2b(mode, $completion, $super) {
    mode = mode === VOID ? VfsOpenMode_READ_getInstance() : mode;
    return $super === VOID ? this.q2a(mode, $completion) : $super.q2a.call(this, mode, $completion);
  }
  r2a(range, $completion) {
    return this.z28_1.a2b(this.a29_1, range, $completion);
  }
  n2b(range, $completion) {
    return this.z28_1.a2b(this.a29_1, toLongRange(range), $completion);
  }
  o2b($completion) {
    return this.z28_1.a2b(this.a29_1, get_LONG_ZERO_TO_MAX_RANGE(), $completion);
  }
  j2b($completion) {
    return this.o2b($completion);
  }
  p2b($completion) {
    return this.o2b($completion);
  }
  q2b(charset, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readString__6uahun.bind(VOID, this, charset), $completion);
  }
  r2b(charset, $completion, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.q2b(charset, $completion) : $super.q2b.call(this, charset, $completion);
  }
  s2b(data, attributes, charset, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_writeString__8z2lpg.bind(VOID, this, data, attributes, charset), $completion);
  }
  t2b(data, attributes, charset, $completion, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.s2b(data, attributes, charset, $completion) : $super.s2b.call(this, data, attributes, charset, $completion);
  }
  t2a($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc_0.bind(VOID, this), $completion);
  }
  u2b($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_exists__ioqez8.bind(VOID, this), $completion);
  }
  v2b(attributes, $completion) {
    return this.z28_1.y2a(this.a29_1, attributes, $completion);
  }
  v2a(attributes, $completion) {
    return this.v2b(toList(attributes), $completion);
  }
  w2b(attributes, $completion) {
    return this.z28_1.z2a(this.a29_1, attributes, $completion);
  }
  x2b(attributes, $completion) {
    return this.w2b(toList(attributes), $completion);
  }
  y2b() {
    return Companion_instance_1.z2b(this);
  }
  toString() {
    return this.z28_1.toString() + '[' + this.a29_1 + ']';
  }
  hashCode() {
    var result = hashCode(this.z28_1);
    result = imul(result, 31) + getStringHashCode(this.a29_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof VfsFile ? other : THROW_CCE();
    if (!equals(this.z28_1, tmp0_other_with_cast.z28_1))
      return false;
    if (!(this.a29_1 === tmp0_other_with_cast.a29_1))
      return false;
    return true;
  }
}
class Companion_1 {
  z2b(jailRoot) {
    return (new JailVfs(jailRoot, Unit_instance)).d2b();
  }
}
class JailVfs extends Proxy {
  constructor(jailRoot, dummy) {
    super();
    this.b2c_1 = jailRoot;
    this.c2c_1 = normalize(this.b2c_1.e29());
  }
  p2a(path, $completion) {
    return this.b2c_1.oi(trim(normalize(get_pathInfo(path)), charArrayOf([_Char___init__impl__6a9atx(47)])));
  }
  g2a() {
    return this.b2c_1.g2a();
  }
  toString() {
    return 'JailVfs(' + this.b2c_1.toString() + ')';
  }
}
class Companion_2 {}
class LocalVfs extends Vfs {
  constructor(fs) {
    fs = fs === VOID ? Companion_getInstance_0() : fs;
    super();
    this.d2c_1 = fs;
  }
  toString() {
    return 'LocalVfs';
  }
}
class UrlVfs extends Vfs {
  constructor(url, dummy, failFromStatus) {
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    super();
    this.e2c_1 = url;
    this.f2c_1 = failFromStatus;
    this.g2c_1 = this.e2c_1;
  }
  g2a() {
    return this.g2c_1;
  }
  h2c(path) {
    var result = trim(this.e2c_1, charArrayOf([_Char___init__impl__6a9atx(47)])) + toString_1(_Char___init__impl__6a9atx(47)) + trim(path, charArrayOf([_Char___init__impl__6a9atx(47)]));
    return result;
  }
}
//endregion
function getUnderlyingUnscapedFile(_this__u8e3s4, $completion) {
  return _this__u8e3s4.z28_1.d29(_this__u8e3s4.a29_1, $completion);
}
function get_fullPathNormalized(_this__u8e3s4) {
  return replace(_PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
}
function _PathInfo___init__impl__vpw96a(fullPath) {
  return fullPath;
}
function _PathInfo___get_fullPath__impl__21fx6x($this) {
  return $this;
}
function get_parent(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(get_folder(_this__u8e3s4));
}
function normalize(_this__u8e3s4, removeEndSlash) {
  removeEndSlash = removeEndSlash === VOID ? true : removeEndSlash;
  var path = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var schemeIndex = indexOf(path, ':');
  var tmp;
  if (schemeIndex >= 0) {
    var tmp_0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = path.substring(schemeIndex);
    if (startsWith(tmp$ret$1, '://')) {
      tmp_0 = 3;
    } else {
      tmp_0 = 1;
    }
    var take = tmp_0;
    // Inline function 'kotlin.text.substring' call
    var endIndex = schemeIndex + take | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = path.substring(0, endIndex);
    // Inline function 'kotlin.text.substring' call
    var startIndex = schemeIndex + take | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = path.substring(startIndex);
    tmp = tmp_1 + normalize(get_pathInfo(tmp$ret$5), removeEndSlash);
  } else {
    var path2 = replace(path, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
    var out = ArrayList.i1();
    var path2PathLength;
    // Inline function 'korlibs.io.file.fastForEachWithIndex' call
    // Inline function 'kotlin.also' call
    var this_0 = split(path2, ['/']);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.normalize.<anonymous>' call
    path2PathLength = this_0.e1();
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.io.file.normalize.<anonymous>' call
      var index = n;
      var part = this_0.d1(n);
      switch (part) {
        case '':
          if (out.g1() || !removeEndSlash) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.h('');
          }

          break;
        case '.':
          if (index === (path2PathLength - 1 | 0) && !removeEndSlash) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.h('');
          }

          break;
        case '..':
          var tmp_2;
          // Inline function 'kotlin.collections.isNotEmpty' call

          if (!out.g1()) {
            tmp_2 = !(index === 1);
          } else {
            tmp_2 = false;
          }

          if (tmp_2) {
            out.r3(out.e1() - 1 | 0);
          }

          break;
        default:
          // Inline function 'kotlin.collections.plusAssign' call

          out.h(part);
          break;
      }
      n = n + 1 | 0;
    }
    tmp = joinToString(out, '/');
  }
  return tmp;
}
function get_pathInfo(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(_this__u8e3s4);
}
function get_baseName(_this__u8e3s4) {
  return substringAfterLast(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
}
function get_baseName_0(_this__u8e3s4) {
  return get_baseName(_this__u8e3s4.e29());
}
function get_folder(_this__u8e3s4) {
  // Inline function 'kotlin.text.substring' call
  var this_0 = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var tmp0_elvis_lhs = lastIndexOfOrNull(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
  var endIndex = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  // Inline function 'kotlin.js.asDynamic' call
  return this_0.substring(0, endIndex);
}
function get_extensionLC(_this__u8e3s4) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  return get_extension(_this__u8e3s4).toLowerCase();
}
function get_folder_0(_this__u8e3s4) {
  return get_folder(_this__u8e3s4.e29());
}
function combine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  return get_pathInfo(isAbsolute(get_pathInfo(access_0)) ? normalize(get_pathInfo(access_0)) : normalize(get_pathInfo(base + '/' + access_0)));
}
function lightCombine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(base) > 0) {
    tmp = trimEnd(base, charArrayOf([_Char___init__impl__6a9atx(47)])) + '/' + trim(access_0, charArrayOf([_Char___init__impl__6a9atx(47)]));
  } else {
    tmp = access_0;
  }
  var res = tmp;
  return get_pathInfo(res);
}
function lastIndexOfOrNull(_this__u8e3s4, char, startIndex) {
  startIndex = startIndex === VOID ? get_lastIndex(_this__u8e3s4) : startIndex;
  // Inline function 'kotlin.takeIf' call
  var this_0 = lastIndexOf(_this__u8e3s4, char, startIndex);
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'korlibs.io.file.lastIndexOfOrNull.<anonymous>' call
  if (this_0 >= 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
function get_extension(_this__u8e3s4) {
  return substringAfterLast(get_baseName(_this__u8e3s4), _Char___init__impl__6a9atx(46), '');
}
function isAbsolute(_this__u8e3s4) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(base) === 0)
    return false;
  var b = substringBefore(replace(base, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(47));
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(b) === 0)
    return true;
  if (contains(b, _Char___init__impl__6a9atx(58)))
    return true;
  return false;
}
var VfsOpenMode_READ_instance;
var VfsOpenMode_WRITE_instance;
var VfsOpenMode_APPEND_instance;
var VfsOpenMode_CREATE_OR_TRUNCATE_instance;
var VfsOpenMode_CREATE_instance;
var VfsOpenMode_CREATE_NEW_instance;
var VfsOpenMode_entriesInitialized;
function VfsOpenMode_initEntries() {
  if (VfsOpenMode_entriesInitialized)
    return Unit_instance;
  VfsOpenMode_entriesInitialized = true;
  VfsOpenMode_READ_instance = new VfsOpenMode('READ', 0, 'rb', false);
  VfsOpenMode_WRITE_instance = new VfsOpenMode('WRITE', 1, 'r+b', true, true);
  VfsOpenMode_APPEND_instance = new VfsOpenMode('APPEND', 2, 'a+b', true, true, VOID, VOID, true);
  VfsOpenMode_CREATE_OR_TRUNCATE_instance = new VfsOpenMode('CREATE_OR_TRUNCATE', 3, 'w+b', true, true, true);
  VfsOpenMode_CREATE_instance = new VfsOpenMode('CREATE', 4, 'w+b', true, true);
  VfsOpenMode_CREATE_NEW_instance = new VfsOpenMode('CREATE_NEW', 5, 'w+b', true);
}
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
var Standard_BINARY_instance;
var Standard_STRING_instance;
var Standard_LONG_instance;
var Standard_INT_instance;
var Standard_entriesInitialized;
function Standard_initEntries() {
  if (Standard_entriesInitialized)
    return Unit_instance;
  Standard_entriesInitialized = true;
  Standard_BINARY_instance = new Standard('BINARY', 0);
  Standard_STRING_instance = new Standard('STRING', 1);
  Standard_LONG_instance = new Standard('LONG', 2);
  Standard_INT_instance = new Standard('INT', 3);
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
function Standard_STRING_getInstance() {
  Standard_initEntries();
  return Standard_STRING_instance;
}
function *_generator_invoke__zhh2q8($this, $this$async, $completion) {
  try {
    var tmp = $this.l2a_1.n2a($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_getUnderlyingUnscapedFile__y1cdv2($this, path, $completion) {
  var tmp = $this.o2a($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.p2a(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = getUnderlyingUnscapedFile(tmp_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_initOnce__uuyf07($this, $completion) {
  if ($this.m2a_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.cd();
    var tmp_0 = CoroutineScope(tmp$ret$0.mn(SupervisorJob()).mn(CoroutineName.o1e('Initializing.' + $this.toString())));
    tmp.m2a_1 = async(tmp_0, VOID, VOID, Vfs$Proxy$initOnce$slambda_0($this));
  }
  var tmp_1 = ensureNotNull($this.m2a_1).k1a($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return $this;
}
function *_generator_open__qjxcea($this, path, mode, $completion) {
  var tmp = $this.o2a($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.p2a(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.q2a(mode, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_readRange__lxd64t($this, path, range, $completion) {
  var tmp = $this.o2a($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.p2a(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.r2a(range, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_put__cb93wb($this, path, content, attributes, $completion) {
  var tmp = $this.o2a($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.p2a(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(attributes);
  var tmp_1 = tmp_0.s2a(content, tmp$ret$0.slice(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_stat__qhnowc($this, path, $completion) {
  var tmp = $this.o2a($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.p2a(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.t2a($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1.i2a($this.u2a(path));
}
function *_generator_mkdir__s6s291($this, path, attributes, $completion) {
  var tmp = $this.o2a($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.p2a(path, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(attributes);
  var tmp_1 = tmp_0.v2a(tmp$ret$0.slice(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function Vfs$Proxy$initOnce$slambda_0(this$0) {
  var i = new Vfs$Proxy$initOnce$slambda(this$0);
  var l = function ($this$async, $completion) {
    return i.a1r($this$async, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_readRange__lxd64t_0($this, path, range, $completion) {
  // Inline function 'korlibs.io.async.useIt' call
  var tmp = $this.w2a(path, VfsOpenMode_READ_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'korlibs.io.async.use' call
  var this_0 = tmp;
  var error = null;
  var tmp_0;
  try {
    // Inline function 'korlibs.io.file.Vfs.readRange.<anonymous>' call
    this_0.x1v_1 = range.i2();
    // Inline function 'kotlin.math.min' call
    // Inline function 'kotlin.Long.minus' call
    var a = (new Long(2147483647, 0)).a2(toLong(1));
    var b = range.h2().a2(range.i2());
    var tmp$ret$1 = a.z1(b) <= 0 ? a : b;
    var tmp_1 = readBytesUpTo(this_0, tmp$ret$1.l2() + 1 | 0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var e = $p;
      error = e;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_0 = tmp_2;
  }
  var result = tmp_0;
  if (this_0 == null)
    null;
  else {
    var tmp_3 = this_0.m1s($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  if (!(error == null))
    throw error;
  return (result == null ? true : !(result == null)) ? result : THROW_CCE();
}
function *_generator_put__cb93wb_0($this, path, content, attributes, $completion) {
  // Inline function 'korlibs.io.async.useThis' call
  var tmp = $this.w2a(path, VfsOpenMode_CREATE_OR_TRUNCATE_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'korlibs.io.async.use' call
  var this_0 = tmp;
  var error = null;
  var tmp_0;
  try {
    // Inline function 'korlibs.io.file.Vfs.put.<anonymous>' call
    var tmp_1 = copyTo(content, this_0, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var e = $p;
      error = e;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_0 = tmp_2;
  }
  var result = tmp_0;
  if (this_0 == null)
    null;
  else {
    var tmp_3 = this_0.m1s($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  if (!(error == null))
    throw error;
  return (result == null ? true : !(result == null)) ? result : THROW_CCE();
}
function unsupported($this) {
  throw UnsupportedOperationException.qa('unsupported for ' + toString_0(getKClassFromExpression($this)) + ' : ' + $this.toString());
}
function *_generator_mkdirs__lgtbdw($this, path, attributes, $completion) {
  if (path === '')
    return false;
  var tmp = $this.x2a(path, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp.q29_1)
    return false;
  var tmp_0 = $this.y2a(path, attributes, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0)
    return true;
  var tmp_1 = $this.z2a(_PathInfo___get_fullPath__impl__21fx6x(get_parent(_PathInfo___init__impl__vpw96a(path))), attributes, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = $this.y2a(path, attributes, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2;
}
function VfsOpenMode_READ_getInstance() {
  VfsOpenMode_initEntries();
  return VfsOpenMode_READ_instance;
}
function VfsOpenMode_CREATE_OR_TRUNCATE_getInstance() {
  VfsOpenMode_initEntries();
  return VfsOpenMode_CREATE_OR_TRUNCATE_instance;
}
function get_LONG_ZERO_TO_MAX_RANGE() {
  _init_properties_VfsFile_kt__9wj0sz();
  return LONG_ZERO_TO_MAX_RANGE;
}
var LONG_ZERO_TO_MAX_RANGE;
function *_generator_readString__6uahun($this, charset, $completion) {
  var tmp = $this.j2b($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return toString_2(tmp, charset);
}
function *_generator_writeString__8z2lpg($this, data, attributes, charset, $completion) {
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp = $this.k2b(toByteArray(data, charset), arrayConcat([attributes, [Companion_instance_0.k2a()]]), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_stat__qhnowc_0($this, $completion) {
  var tmp0_elvis_lhs = $this.b29_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0 = $this.z28_1.x2a($this.a29_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function *_generator_exists__ioqez8($this, $completion) {
  // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
  var tmp;
  try {
    // Inline function 'korlibs.io.file.VfsFile.exists.<anonymous>' call
    var tmp_0 = $this.z28_1.x2a($this.a29_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0.q29_1;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      if (false) {
        printStackTrace(e);
      }
      tmp_1 = null;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
}
function *_generator_readAsSyncStream__xvjwgr(_this__u8e3s4, $completion) {
  var tmp = _this__u8e3s4.j2b($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return openSync(tmp);
}
function readAsSyncStream(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readAsSyncStream__xvjwgr.bind(VOID, _this__u8e3s4), $completion);
}
function toLongRange(_this__u8e3s4) {
  _init_properties_VfsFile_kt__9wj0sz();
  return toLong(_this__u8e3s4.i2()).c2(toLong(_this__u8e3s4.h2()));
}
var properties_initialized_VfsFile_kt_lqx1ld;
function _init_properties_VfsFile_kt__9wj0sz() {
  if (!properties_initialized_VfsFile_kt_lqx1ld) {
    properties_initialized_VfsFile_kt_lqx1ld = true;
    LONG_ZERO_TO_MAX_RANGE = (new Long(0, 0)).c2(new Long(-1, 2147483647));
  }
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  return Companion_instance_2;
}
//region block: post-declaration
initMetadataForClass(FinalVfsFile, 'FinalVfsFile');
initMetadataForClass(VfsNamed, 'VfsNamed');
initMetadataForClass(VfsOpenMode, 'VfsOpenMode');
initMetadataForClass(VfsStat, 'VfsStat');
initMetadataForCompanion(Companion);
protoOf(VfsCachedStatContext).pd = get;
protoOf(VfsCachedStatContext).ln = fold;
protoOf(VfsCachedStatContext).kn = minusKey;
protoOf(VfsCachedStatContext).mn = plus;
initMetadataForClass(VfsCachedStatContext, 'VfsCachedStatContext', VOID, VOID, [Element]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(Standard, 'Standard');
initMetadataForLambda(Vfs$Proxy$initOnce$slambda, VOID, VOID, [1]);
initMetadataForClass(Vfs, 'Vfs', VOID, VOID, VOID, [1, 0, 2, 4, 3]);
initMetadataForClass(Proxy, 'Proxy', VOID, VOID, VOID, [1, 0, 4, 2, 3]);
initMetadataForClass(VfsFile, 'VfsFile', VOID, VOID, VOID, [0, 2, 3, 1, 4, 5]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(JailVfs, 'JailVfs', VOID, VOID, VOID, [1, 0, 4, 2, 3]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(LocalVfs, 'LocalVfs', VOID, VOID, VOID, [1, 4, 0, 2, 3]);
initMetadataForClass(UrlVfs, 'UrlVfs', VOID, VOID, VOID, [1, 0, 2, 4, 3]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
//endregion
//region block: exports
export {
  VfsOpenMode_READ_getInstance as VfsOpenMode_READ_getInstance1f4z3vmo4033h,
  getUnderlyingUnscapedFile as getUnderlyingUnscapedFilej1r5tpfxb7a7,
  readAsSyncStream as readAsSyncStream2ficq0l6vek7d,
  _PathInfo___init__impl__vpw96a as _PathInfo___init__impl__vpw96aee5jvc40cw94,
  _PathInfo___get_fullPath__impl__21fx6x as _PathInfo___get_fullPath__impl__21fx6x1rfietgv3lnmb,
  Companion_instance as Companion_instance28oneptpyw0i3,
  LocalVfs as LocalVfs18bzski76hhpp,
  UrlVfs as UrlVfs292f1sja450ff,
  Proxy as Proxy2ri7nr2ijtx4g,
  VfsCachedStatContext as VfsCachedStatContext2gte5m09f8ox9,
  Vfs as Vfs3mgmizq3oi7gy,
  get_baseName as get_baseName7iz3sifr1imo,
  get_baseName_0 as get_baseName2yf63efofm8te,
  get_extensionLC as get_extensionLCr5nk7cwvpg7s,
  normalize as normalize34ppus0f5oo02,
  get_parent as get_parent1emraos91g459,
  get_pathInfo as get_pathInfo26tycr2r540oz,
};
//endregion
